module.exports = "/assets/bfc00160a0b354f13ee4623b8181439f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OZ.png
// module id = 1698
// module chunks = 0